export enum PriorityRating {
  NR = 'NR',
  HM = 'HM',
  H = 'H',
  HT = 'HT',
  T1 = 'T1',
  T2 = 'T2',
  T3 = 'T3',
  NT = 'NT',
  SWF = 'SWF'
}

export enum PriorityRatingLocalized {
  NR = 'NR',
  HM = 'OV',
  H = 'H',
  HT = 'UN',
  T1 = 'T1',
  T2 = 'T2',
  T3 = 'T3',
  NT = 'NT',
  SWF = 'SWF'
}

export enum PriorityRatingGroup {
  Holders = 'holders',
  Targets = 'targets',
  SWF = 'SWF'
}

export const PriorityRatingGroups = {
  [PriorityRating.HM]: PriorityRatingGroup.Holders,
  [PriorityRating.H]: PriorityRatingGroup.Holders,
  [PriorityRating.HT]: PriorityRatingGroup.Holders,
  [PriorityRating.T1]: PriorityRatingGroup.Targets,
  [PriorityRating.T2]: PriorityRatingGroup.Targets,
  [PriorityRating.T3]: PriorityRatingGroup.Targets,
  [PriorityRating.NT]: PriorityRatingGroup.Targets,
  [PriorityRating.SWF]: PriorityRatingGroup.SWF,
  [PriorityRating.NR]: ''
};
